<template>
  <section id="location" class="anchor-section">
    <div class="section-header">
      <a-space align="center">
        <div class="title_icon"></div>
        <div class="ant-descriptions-title section-title">位置周边</div>
      </a-space>
    </div>

    <TdtMap
      v-if="bidInfoLoaded"
      :tk="tk"
      :center="[houseBaseInfo.lng, houseBaseInfo.lat]"
      :markers="markerList"
      :zoom="15"
    />
    <div v-else class="mapLoading">
    <a-spin />
  </div>
  </section>
</template>

<script>
import TdtMap from "@/components/TdtMap.vue";
export default {
  props: {
    bidBaseInfo: {
      type: Object,
      default: () => null,
    },
    houseBaseInfo: {
      type: Object,
      default: () => null,
    },
    bidInfoLoaded: {
      type: Boolean,
      default: false,
    },
  },
  components: { TdtMap },
  data() {
    return {
      tk: "a3789da931616fce36077d6fd5712667",
      map: null,
    };
  },

  computed: {
    markerList() {
      const houseInfo = this.houseBaseInfo || {};
      const bidInfo = this.bidBaseInfo || {};

      if (!houseInfo.lng || !houseInfo.lat) {
        return [];
      }

      return [
        {
          lng: houseInfo.lng,
          lat: houseInfo.lat,
          icon: require("@/assets/locationMap3.png"),
          housePic: houseInfo.tableHousingCover,
          data: {
            address: houseInfo.housingResName,
            leaseType: bidInfo.leaseType,
            decorate: bidInfo.currentSituationDecoration,
            leaseUseType: houseInfo.leaseUseType,
          },
        },
      ];
    },
  },

  methods: {

  },
};
</script>

<style scoped>
.anchor-section {
  scroll-margin-top: 120px;
}

.section-header {
  margin: 30px 4px 14px;
}

.section-title {
  font-size: 16px;
  margin-bottom: 0;
}

.title_icon {
  width: 8px;
  height: 26px;
  margin-right: 10px;
  background: #007aff;
  border-radius: 0 3px 3px 0;
}

.desc-label-text {
  font-weight: 500;
}
.mapLoading {
  text-align: center;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  padding: 250px 50px;
}
</style>